import LayoutRoutes from "../Utilities/LayoutRoutes";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import useDescriptionTitle from "../hooks/useDescriptionTitle";
import { useEffect } from "react";
import { GetMachineList } from "../../store/Machines.store";

const Home: React.FC = () => {
  const machines = useAppSelector((state) => state.machines.machines);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(GetMachineList());
  }, [dispatch]);
  useDescriptionTitle("Organize your Machines", "All Machines");
  return (
    <>
      
      <LayoutRoutes title="All Machines" machines={machines}></LayoutRoutes>

    </>
  );
};

export default Home;
